import { css } from '@emotion/css'
import appSettings from '../../app/app-settings'

const programCss = {
  timeline: () => css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  }),

  timelineItem: () => css({
    display: "flex",
    alignItems: "center",
    gap: 28,
    width: 800,
    maxWidth: "100%",
    paddingBlock: 15,

    [appSettings.mediaQueries.smallTablet]: {
      gap: 20,
    },
  }),

  time: (visible: boolean) => css({
    fontSize: 26,
    fontFamily: "CinzelRegular",
    width: 74,
    minWidth: 74,
    whiteSpace: "nowrap",
    visibility: visible ? "visible" : "hidden",

    [appSettings.mediaQueries.smallTablet]: {
      minWidth: 62,
      width: 62,
      fontSize: 22,
    },

    [appSettings.mediaQueries.mobile]: {
      minWidth: 52,
      width: 52,
      fontSize: 18,
    },
  }),

  icon: () => css({
    height: 70,
    minWidth: 70,
    width: 70,
    objectFit: "contain",

    [appSettings.mediaQueries.smallTablet]: {
      height: 55,
      minWidth: 55,
      width: 55,
    },

    [appSettings.mediaQueries.mobile]: {
      height: 45,
      minWidth: 45,
      width: 45,
    },
  }),

  name: (visible: boolean) => css({
    fontSize: 24,
    fontFamily: "CinzelRegular",
    color: appSettings.colors.blueColor,
    visibility: visible ? "visible" : "hidden",

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 20,
    },

    [appSettings.mediaQueries.mobile]: {
      fontSize: 18,
    },
  }),

  description: (visible: boolean) => css({
    fontSize: 18,
    visibility: visible ? "visible" : "hidden",

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 14,
    },
  }),

  info: () => css({
    backgroundColor: appSettings.colors.blueBackground,
    padding: 20,
    textAlign: "center",
    marginInline: 25,
  }),
}

export default programCss
